import AppState from 'AppState';

/**
 * Get the current `window.location`, without the tenant prefix (if there is one)
 * @returns
 */
export const GetCurrentLocationWithoutPrefix = () => {
	// Remove tenant prefix from path, if it exists
	let splitPathname = window.location.pathname.split('/');
	if (splitPathname.length > 2 && splitPathname[1] == AppState.tenantBaseUrl.replace('/', '')) {
		splitPathname = splitPathname.slice(2);
	} else {
		// This should be very rare, if not impossible, but just in case...
		splitPathname = splitPathname.slice(1);
	}
	const currentPathname = '/' + splitPathname.join('/');

	return {
		pathname: currentPathname,
		search: location.search,
	};
};
